import { CheckoutState } from '@shared/types';
import { PublicCourse, PublicEducator } from '@cademy-package/sdk-component-types';
import { ResponseSubmitter } from '../useCheckout';
import { CademyError } from '@shared/domain-shared';
import { createContext, useContext } from 'react';
import { PaymentOptions } from '../data/usePaymentOptions';

export type CheckoutContext<
    TCheckoutState extends CheckoutState = CheckoutState,
    CourseType extends PublicCourse = PublicCourse,
    EducatorType extends PublicEducator = PublicEducator,
> = {
    checkoutState: TCheckoutState;
    isLoading: boolean;
    submitResponse: ResponseSubmitter<TCheckoutState>;
    error: CademyError | null;
    course: CourseType;
    educator: EducatorType;
    paymentOptions: PaymentOptions;
};

const CheckoutContext = createContext<Error | CheckoutContext>(
    new Error(
        'Attempted to useCheckoutContext in a Component not wrapped in CheckoutContextProvider'
    )
);

export const CheckoutContextProvider = CheckoutContext.Provider;

export const useCheckoutContext = (): CheckoutContext<
    CheckoutState,
    PublicCourse,
    PublicEducator
> => {
    const context = useContext(CheckoutContext);
    if (context instanceof Error) {
        throw context;
    }
    return context;
};
